<template>
  <div style="position: relative;" >
    <!-- <div class="function">
      <div  class="">统计函数：{{centerTitle}}</div>
      <div  class="">产品名称：{{productName}}</div>
    </div> -->
    <emptyShow v-if="!hasData"></emptyShow>
    <div id="main" class="bar-chart" ></div>
  </div>
</template>
<script>
import echarts from 'echarts'
import emptyImg from '@img/empty.png'
import emptyShow from '@/components/empty_view'
// import { eventBus } from '@/utils/eventBus'
export default {
  name: 'barChart',
  components: {
    emptyShow
  },
  props: ['data', 'refresh', 'title', 'unitName', 'centerTitle', 'productName'],
  data () {
    return {
      emptyImg,
      myChart: ''
    }
  },
  created () {
    // eventBus.$on('refresh-chart', this.initEcharts)
  },
  mounted () {
    if (this.data && this.data.xData) {
      this.initEcharts()
    }
  },
  watch: {
    refresh () {
      console.log('refresh变化了')
      this.initEcharts()
    }
  },
  computed: {
    hasData () {
      return (this.data && this.data.xData && this.data.xData.length > 0)
    }
  },
  methods: {
    initEcharts () {
      this.myChart = echarts.init(document.getElementById('main'))
      this.myChart.clear()// 清除后重新绘制
      this._setOption()
      const that = this
      this.myChart.on('datazoom', function (params) {
        if (params.batch[0].end === 100) { // 证明拉到底了，请求下一页
          console.log('请求下一页')
          that.$emit('next-page')
        }
        console.log('触发的params：', params)
      })
    },
    _setOption () {
      const options = {
        backgroundColor: 'white',
        tooltip: { // 提示框组件
          trigger: 'axis',
          formatter: '{b}<br />{a0}: {c0}',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          textStyle: {
            color: '#fff',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12
          }
        },
        grid: {
          left: '2%',
          right: '5%',
          bottom: '5%',
          top: '10%',
          // padding:'0 0 10 0',
          containLabel: true
        },
        legend: { // 图例组件，颜色和名字
          right: '10%',
          itemGap: 16,
          itemWidth: 10,
          itemHeight: 10,
          data: [{
            name: '装机总数'
          }],
          textStyle: {
            color: '#a8aab0',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12
          }
        },
        xAxis: [
          {
            name: '时间',
            type: 'category',
            // boundaryGap: true,//坐标轴两边留白
            data: this.data.xData,
            // ['22:18', '22:23', '22:25', '22:28', '22:30', '22:33', '22:35', '22:40', '22:18', '22:23', '22:25', '22:28', '22:30', '22:33', '22:35', '22:40', '22:40', '22:40', '22:40', '22:40', '22:40', '22:55', '22:55', '22:55', '22:55', '22:55'],
            axisLabel: { // 坐标轴刻度标签的相关设置。
            // interval: 0,//设置为 1，表示『隔一个标签显示一个标签』
            // margin:15,
              textStyle: {
                color: '#078ceb',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12
              },
              rotate: 50
            },
            axisTick: { // 坐标轴刻度相关设置。
              show: false
            },
            axisLine: { // 坐标轴轴线相关设置
              lineStyle: {
                color: 'black',
                opacity: 0.2
              }
            },
            splitLine: { // 坐标轴在 grid 区域中的分隔线。
              show: false
            }
          }
        ],
        yAxis: [
          {
            name: this.unitName || '数值',
            type: 'value',
            splitNumber: 5,
            axisLabel: {
              textStyle: {
                color: '#a8aab0',
                fontStyle: 'normal',
                fontFamily: '微软雅黑',
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'black',
                opacity: 0.2
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#fff'],
                opacity: 0.06
              }
            }

          }
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 99
          },
          {
            start: 0,
            end: 99,
            handleSize: '80%',
            handleStyle: {
              color: '#fff',
              shadowBlur: 3,
              shadowColor: 'rgba(0, 0, 0, 0.6)',
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            bottom: 0
          }
        ],
        series: this.data.barSeries
        // series: [
        //   {
        //     name: this.title || '装机总数',
        //     type: 'bar',
        //     data: this.data.yData,
        //     barWidth: 10,
        //     barGap: 0, // 柱间距离
        //     itemStyle: {
        //       normal: {
        //         show: true,
        //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //           offset: 0,
        //           color: '#5768EF'
        //         }, {
        //           offset: 1,
        //           color: 'pink'
        //         }])
        //       }
        //     }
        //   }
        // ]
      }

      this.myChart.setOption(options)
    }
  }
}
</script>

<style lang='less' scoped>
   .bar-chart{
     height: 450px;
     padding-top: 20px;
   }
    .function{
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 20px;
      z-index:9999
    }
</style>
